import React from "react";
import "./Frame11532.css";
import { Link } from "react-router-dom";

function Frame11532() {
  return (
    <Link to="/acquisition">
      <div className="frame-115-96">
        <div className="new-case-1 valign-text-middle inter-medium-star-dust-18px">New case</div>
      </div>
    </Link>
  );
}

export default Frame11532;
